// Module
var code = "<div class=chart-wrapper><div class=chart-area-wrapper><div class=chart-area-wrapper-2 ng-class=$ctrl.getDynamicWidth()><canvas></canvas></div></div><canvas class=surrogate-canvas height=300 width=0></canvas></div>";
// Exports
module.exports = code;